import { Injectable } from '@angular/core';

import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { TeamActions } from '@app/core/actions';

@Injectable({
  providedIn: 'root'
})
export class AccountHasDomainGuard  {

  constructor(private store$: Store<fromRoot.State>) { }

  canActivate(): Observable<boolean> {
    return this.store$.select(fromRoot.getUserTeams).pipe(
      map(teams => teams.length > 0),
      take(1),
    );
  }
}
